/**
 * Shared shape for every list-page query. Every list page in Kollez uses this contract:
 *
 *   const { data, params, setQ, setFilter, setSort, setPage, reset } = useTableQuery(...)
 *
 * The API endpoint accepts identical query params: page, limit, q, sort, order + per-page filters.
 * Server-side always — never client-side filter across a subset of rows.
 */
export interface TableQueryParams {
  page: number;
  limit: number;
  q?: string;                   // free-text search
  sort?: string;                // column key
  order?: 'asc' | 'desc';
  [k: string]: unknown;         // per-page filters (e.g. status, plan)
}

export interface Paginated<T> {
  rows: T[];
  page: number;
  limit: number;
  total: number;
  totalPages: number;
}

export const DEFAULT_LIMIT = 25;

export function toQueryString(p: TableQueryParams): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) {
    if (v === undefined || v === null || v === '') continue;
    sp.set(k, String(v));
  }
  return sp.toString();
}

/** Build initial params. Callers usually spread additional per-page defaults on top. */
export function initialTableParams(overrides: Partial<TableQueryParams> = {}): TableQueryParams {
  return { page: 1, limit: DEFAULT_LIMIT, ...overrides };
}
